import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { jobShape } from '../../../../proptypes/job';
import { RecommendationsNavigation, SearchNavigation, SimilarJobsNavigation } from './components';
import { getContext } from './navigation-selectors';

const mapStateToProps = ({ search }, props) => getContext(search, props);

const NAVIGATORS = {
  search: SearchNavigation,
  reco: RecommendationsNavigation,
  similar_postings: SimilarJobsNavigation,
  default: SimilarJobsNavigation,
};

export const NavigationContainer = ({ className, pagingContext, job }) => {
  const Navigation = NAVIGATORS[pagingContext] || NAVIGATORS.default;
  return <Navigation className={className} job={job} />;
};

NavigationContainer.propTypes = {
  job: jobShape,
  pagingContext: PropTypes.string,
  className: PropTypes.string,
};

export default withRouter(connect(mapStateToProps)(NavigationContainer));
